<script setup lang="ts">
import { computed } from 'vue'
import { LayoutGrid, List } from '@lucide/vue'
import { Button, Field, Label, Select } from 'catalyst-vue'
import { comicSortOrders, type ComicSortOrder } from '../../lib/comic-sort'
import { useLibraryDisplay } from '../../lib/library-preferences'
import { useControlSize } from '../../lib/library-layout'

// 偏好是共用的單例，本地與私人雲端讀同一份，因此這個元件不需要知道目前是哪個範圍。
const display = useLibraryDisplay()
const controlSize = useControlSize()

// 標籤刻意短：這個控制項與搜尋、篩選同列，長標籤會把整列撐開並讓右側擠成一團。
// 但「時間」太含糊——它指的是加入書庫的時間，不是備份或修改的時間。
const sortLabels: Record<ComicSortOrder, string> = {
  'added-desc': '加入時間 新→舊',
  'added-asc': '加入時間 舊→新',
  'title-asc': '標題 A→Z',
  'title-desc': '標題 Z→A',
}

const sortOrder = computed({
  get: () => display.sortOrder.value,
  set: value => display.setSortOrder(value as ComicSortOrder),
})
// 可及名稱描述「按下去會變成什麼」，不是目前狀態——否則按鈕在朗讀時像是在陳述現況。
// 看得見的文字同樣是目標模式，與圖示一致；完整句子留給 title 與可及名稱。
const isList = computed(() => display.viewMode.value === 'list')
const toggleLabel = computed(() => isList.value ? '切換為書架檢視' : '切換為列表檢視')
const toggleText = computed(() => isList.value ? '書架' : '列表')
function toggleViewMode() { display.setViewMode(isList.value ? 'shelf' : 'list') }
</script>

<template>
  <div class="library-display-controls">
    <Field class="library-sort">
      <Label class="sr-only">排序方式</Label>
      <Select v-model="sortOrder" :size="controlSize">
        <option v-for="order in comicSortOrders" :key="order" :value="order">{{ sortLabels[order] }}</option>
      </Select>
    </Field>
    <Button
      outline
      :size="controlSize"
      class="library-view-toggle"
      :aria-label="toggleLabel"
      :title="toggleLabel"
      @click="toggleViewMode"
    >
      <component :is="isList ? LayoutGrid : List" :size="17" aria-hidden="true" />{{ toggleText }}
    </Button>
  </div>
</template>
